"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.likelyWireless = exports.root = exports.doc = void 0;
exports.doc = document;
exports.root = exports.doc.documentElement || exports.doc;
exports.likelyWireless = 'orientation' in window;
